import { registerAppInsights } from "../../lib/appinsights";
import * as session from "../../lib/session";
import "../../lib/polyfills";
import { getElement } from "../../lib/elementUtils";
import { getCookieSettings, setCookieSettings } from "../../lib/cookies";

/** Convert a number of minutes to milliseconds */
const minsToMs = (mins: number) => mins * 60 * 1000;

/**
 * On click of the "back to top" button, scroll the users' viewport to the top fo the page
 */
function registerBackToTopButton() {
    const backToTopButton = getElement(document, ".button__footer-link-top", "back-to-top button");
    backToTopButton?.addEventListener("click", () => {
        window.scrollTo({
            top: 0
        });
    })
}

/** Register event listeners for the cookie banner */
function registerCookieBanner() {
    const cookieBanner = getElement(document, ".cookie-banner");
    const hideCookieBanner = () => cookieBanner.classList.add("hidden");
    const showCookieBanner = () => cookieBanner.classList.remove("hidden");
    const acceptCookiesButton = document.querySelector(".cookie-banner__accept-cookies");

    // Hide the cookies banner if the user has previously hidden it
    const cookieSettings = getCookieSettings();
    if (cookieSettings?.hasHiddenBanner) {
        hideCookieBanner()
    } else {
        showCookieBanner()
    }

    // On click of the "accept cookies" button, hide the banner and set a cookie to hide the banner for the duration of the session
    acceptCookiesButton?.addEventListener("click", () => {
        const cookieSettings = getCookieSettings();
        cookieSettings.hasHiddenBanner = true;
        setCookieSettings(cookieSettings);
        hideCookieBanner();
    });
}

async function run() {
    registerAppInsights();
    registerBackToTopButton();
    registerCookieBanner();

    const sessionOptions = await session.getOptions();

    session.registerTimeoutWarning(minsToMs(sessionOptions.timeBeforeWarning));

    session.registerTimeout(minsToMs(sessionOptions.timeoutDuration));

    document
        .querySelector("input[type='button'][value='Logout']")
        ?.addEventListener("click", () => {
            session
                .end()
                .then(() => (window.location.href = window.location.origin));
        });
}

run();
